export default {
  dimension: {
    props: {
      uniqueName: 'UniqueName',
      name: 'Name'
    },
    routes: {
      list: 'GetDimensions',
      hierarchies: 'GetHierarchies',
      members: 'GetMembers'
    },
    uniqueName (dimension) {
      return dimension.UniqueName
    },
    name (dimension) {
      return dimension.Name
    }
  },
  measure: {
    props: {
      uniqueName: 'UniqueName',
      name: 'Name'
    },
    routes: {
      list: 'GetMeasures'
    },
    dimensions (measure) {
      return measure.Dimensions
    },
    uniqueName (measure) {
      return measure.UniqueName
    },
    name (measure) {
      return measure.Name
    },
    unit (measure) {
      return measure.Unit
    },
    groupName (measure) {
      return measure.GroupName
    }
  },
  data: {
    routes: {
      query: 'ExecuteQuery'
    },
    parent (data, index) {
      return data[`Group${index || 0}Parent`]
    },
    key (data, index) {
      return data[`Group${index || 0}Key`]
    }
  },
  target: {
    method: 'POST'
  },
  version: '1',
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/api/v1.js